import { Box } from "@mui/material";
import ProjectUsersForm from "../../../components/ProjectUsersForm/ProjectUsersForm";
import ProjectTabSkeleton from "../../../components/ProjectTabSkeleton/ProjectTabSkeleton";
import useProjectTools from "../../../hooks/useProjectTools";
import useProjectAccess from "../../../hooks/useProjectAccess";
import { useProjectUsersTable } from "../../../hooks/useProjectUsersTable";
import usePageTitle from "../../../../../Common/hooks/usePageTitle";

interface ProjectUsersTabProps {
  userCanEdit: boolean;
  id: string;
  projectName: string;
  packageId: string;
  useCustomRoleMapping: boolean;
}

const ProjectUsersTab = ({ id, projectName, packageId, useCustomRoleMapping, userCanEdit }: ProjectUsersTabProps) => {
  usePageTitle("Project | Users");
  const { projectTools, isLoading: isProjectToolsLoading } =
    useProjectTools(id);
  const { projectAccess, isLoading: isProjectAccessLoading } =
    useProjectAccess(id);
  const { fetchGridData } = useProjectUsersTable();

  if (isProjectToolsLoading || isProjectAccessLoading) {
    return <ProjectTabSkeleton variant="users" />;
  }

  return (
    <Box sx={{ pl: "80px", pt: "24px", height: "100%", minHeight: 0, position: "relative" }}>
      {projectTools && projectAccess && (
        <ProjectUsersForm
          projectId={id}
          projectName={projectName}
          packageId={packageId}
          useCustomRoleMapping={useCustomRoleMapping}
          userCanEdit={userCanEdit}
          projectTools={projectTools}
          projectAccess={projectAccess}
          fetchGridData={fetchGridData}
        />
      )}
    </Box>
  );
};

export default ProjectUsersTab;
